import type { Boat, InventoryMediaItem, InventoryMediaSize } from '../types/boat.types';

interface ResolveMediaOptions {
  allowOriginalFallback?: boolean;
}

export const resolveMediaUrl = (
  media?: InventoryMediaItem | null,
  size: InventoryMediaSize = 'card',
  options: ResolveMediaOptions = {},
): string | null => {
  if (!media) return null;
  const allowOriginalFallback = options.allowOriginalFallback ?? true;

  const conversionUrl = media.conversions?.[size] || null;
  if (conversionUrl) return conversionUrl;

  return allowOriginalFallback ? media.url ?? null : null;
};

export const resolveBoatImageUrl = (
  boat?: Boat | null,
  size: InventoryMediaSize = 'card',
  options: ResolveMediaOptions = {},
): string | null => {
  if (!boat) return null;
  const allowOriginalFallback = options.allowOriginalFallback ?? true;

  const primaryMedia = boat.primary_image || boat.images?.[0] || null;
  const resolvedUrl = resolveMediaUrl(primaryMedia, size, options);
  if (resolvedUrl) return resolvedUrl;

  if (!allowOriginalFallback) return null;

  return boat.primary_image_url || boat.images?.[0]?.url || null;
};
